import React, { useEffect } from "react";
import history from "../../../history";
import Emblem from "../../../assets/Icons/emblem.png";
import { withTranslation } from "react-i18next";
import i18n from "../../../utils/LanguageSelector/i18n";
import { menuLabels } from "../../../utils/Data/dataTexts";

function DashboardMenu({ ...props }) {
  const [openMenu, setOpenMenu] = React.useState(false);
  const [mainActive, setMainActive] = React.useState("");

  const name = props.user
    ? `${props.userAccount.lastname} ${props.userAccount.firstname}`
    : "Admin";
  const companyname = props.user ? props.userAccount.companyname : "SkyU";

  useEffect(() => {
    setMainActive(props.activeStep);
  }, [props.activeStep, props.user]);

  const setClassName = (label, classN) => {
    classN = "MenuItem";
    if (label === mainActive) {
      classN = "MenuItem Highlighted";
    }
    return classN;
  };

  const handleClick = (label) => {
    setMainActive(label);
    props.handleNavigation(label);
  };
  return (
    <div className={openMenu ? "DashboardMenu OpenMenu" : "DashboardMenu"}>
      <div className="UserInfo">
        {props.documents ? (
          <>
            <img src={Emblem} alt="emblem" />
            <p style={{ marginLeft: "20px" }}>
              SKYU
              <br />
              <span>Document Management</span>
            </p>
          </>
        ) : (
          <>
            {" "}
            <img src={Emblem} alt="emblem" />
            <p style={{ marginLeft: "20px" }}>
              {name}

              <br />
              <span>{companyname}</span>
              <br />
              <span
                className="LogoutLink"
                onClick={() => {
                  localStorage.removeItem("JWT");
                  localStorage.removeItem("token");
                  history.push("/signin");
                }}
              >
                {i18n.t("general.logout")}
              </span>
            </p>
          </>
        )}
      </div>
      <div className="ExtraItem">
        <li onClick={() => setOpenMenu(!openMenu)} className={"MenuItem"}>
          {`${mainActive}`}
          <span className="MenuIcon">{openMenu ? "X" : "☰"}</span>
        </li>
      </div>
      {props.menuItems.map((item) => {
        return (
          <li
            key={item.label}
            id={item.label}
            onClick={() => {
              if (item.label === "New Order") {
                history.push("/form");
              }
              handleClick(item.label);
            }}
            className={setClassName(item.label, item.classN)}
          >
            {menuLabels[item.label]}
          </li>
        );
      })}
    </div>
  );
}

export default withTranslation()(DashboardMenu);
